(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.unknown = mod.exports;
  }
})(this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var en = {
    ok: 'OK',
    cancel: 'Cancel'
  };
  var zh = {
    ok: '确定',
    cancel: '取消'
  };
  var _default = {
    en: en,
    zh: zh
  };
  _exports.default = _default;
});